var _rect, _rect2, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 325,
    viewBox: "0 0 322 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.24,
    x: 95.8652,
    y: 96.625,
    width: 130.269,
    height: 131.605,
    stroke: "url(#paint0_linear_920_415)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 73.1504,
    y: 73.9111,
    width: 175.697,
    height: 177.034,
    stroke: "url(#paint1_linear_920_415)",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 50.4375,
    y: 51.1963,
    width: 221.126,
    height: 222.462,
    stroke: "url(#paint2_linear_920_415)",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 27.7227,
    y: 28.4824,
    width: 266.555,
    height: 267.891,
    stroke: "url(#paint3_linear_920_415)",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    x: 1,
    y: 1.75977,
    width: 320,
    height: 321.336,
    stroke: "url(#paint4_linear_920_415)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_920_415",
    x1: 96.8652,
    y1: 215.723,
    x2: 227.485,
    y2: 207.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_920_415",
    x1: 74.1504,
    y1: 234.404,
    x2: 251.027,
    y2: 223.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_920_415",
    x1: 51.4375,
    y1: 253.085,
    x2: 274.571,
    y2: 238.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_920_415",
    x1: 28.7227,
    y1: 271.766,
    x2: 298.113,
    y2: 254.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_920_415",
    x1: 2,
    y1: 293.744,
    x2: 325.811,
    y2: 273.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.72c8a99a5bfd2c30407233bb6ba224c7.svg";
export { ForwardRef as ReactComponent };